module.exports = __webpack_public_path__ + "static/study_guide_thumb-5ec836f93a70e42d0cab2c0d44868876.jpg";